import { Component, OnInit } from '@angular/core';
import { MenuItem, SelectItem } from 'primeng/api';
import { RolWidgetsServices } from '../../_services/rol-widget.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { UsuarioWidgetService } from '../../_services/usuario-widget.service';
import { UsuarioWidget } from '../../_models/usuario-widget';
import { TerceroCargoService } from '../../_services/tercero-cargo.service';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { AgrupacionService } from '../../_services/agrupacion.service';
import { TerceroCargo } from '../../_models/tercero-cargo';
import { NavService } from '../../_services/_nav.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PlantillaService } from '../../_services/plantilla.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { NOTIFICACIONRESPONSABILIDAD } from '../../utils/mensajes';

@Component( {
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html'
} )

export class DashboardComponent implements OnInit {

  cities: SelectItem[];

  cars: any[];

  cols: any[];

  selectedCar: any;

  chartData: any;

  events: any[];

  selectedCity: any;

  items: MenuItem[];

  verTercerosCargos = false;

  widUsuario: UsuarioWidget[] = [];

  todWidgets: any[] = [];

  lisRolesWidgets: any[] = [];

  widget: UsuarioWidget;

  verWidgets = false;

  carWidgets = true;

  carInformacionTercero = false;

  nivUsuario: number;

  terCargo: TerceroCargo = {} as TerceroCargo;

  /* variables notifiacion responsabilidad */
  showModalNotificacionResponsabilidad = false;
  defaultMessage: any;
  plantilla: any;
  display: boolean = false;

  todosObligatorios: boolean = false;

  constructor( private rolWidgetServicio: RolWidgetsServices,
               private autServicio: AutenticacionService,
               private terCargoServicio: TerceroCargoService,
               private estFisicaServicio: EstructuraFisicaService,
               private agrServicio: AgrupacionService,
               private navServicio: NavService,
               private usuWidgetServicio: UsuarioWidgetService,
               private sanitizer: DomSanitizer,
              private plantillaService: PlantillaService,
              private router: Router,
              private route: ActivatedRoute, ) {
  }

  ngOnInit() {
    console.log('dashboard......................');
    this.cargarInformacionTercero();

    const cars = [
      { 'brand': 'VW', 'year': 2012, 'color': 'White', 'vin': 'dsad231ff' },
      { 'brand': 'Audi', 'year': 2011, 'color': 'Black', 'vin': 'gwregre345' },
      { 'brand': 'Renault', 'year': 2005, 'color': 'Gray', 'vin': 'h354htr' },
      { 'brand': 'BMW', 'year': 2003, 'color': 'Blue', 'vin': 'j6w54qgh' },
      { 'brand': 'Mercedes', 'year': 1995, 'color': 'White', 'vin': 'hrtwy34' },
      { 'brand': 'Volvo', 'year': 2005, 'color': 'Black', 'vin': 'jejtyj' },
      { 'brand': 'Honda', 'year': 2012, 'color': 'Yellow', 'vin': 'g43gr' },
      { 'brand': 'Jaguar', 'year': 2013, 'color': 'White', 'vin': 'greg34' },
      { 'brand': 'Ford', 'year': 2000, 'color': 'Black', 'vin': 'h54hw5' },
      { 'brand': 'Fiat', 'year': 2013, 'color': 'Red', 'vin': '245t2s' }
    ];

    this.cars = cars;

    const data = [
      {
        'id': 1,
        'title': 'All Day Event',
        'start': '2016-01-01'
      },
      {
        'id': 2,
        'title': 'Long Event',
        'start': '2016-01-07',
        'end': '2016-01-10'
      },
      {
        'id': 3,
        'title': 'Repeating Event',
        'start': '2016-01-09T16:00:00'
      },
      {
        'id': 4,
        'title': 'Repeating Event',
        'start': '2016-01-16T16:00:00'
      },
      {
        'id': 5,
        'title': 'Conference',
        'start': '2016-01-11',
        'end': '2016-01-13'
      },
      {
        'id': 6,
        'title': 'Meeting',
        'start': '2016-01-12T10:30:00',
        'end': '2016-01-12T12:30:00'
      },
      {
        'id': 7,
        'title': 'Lunch',
        'start': '2016-01-12T12:00:00'
      },
      {
        'id': 8,
        'title': 'Meeting',
        'start': '2016-01-12T14:30:00'
      },
      {
        'id': 9,
        'title': 'Happy Hour',
        'start': '2016-01-12T17:30:00'
      },
      {
        'id': 10,
        'title': 'Dinner',
        'start': '2016-01-12T20:00:00'
      },
      {
        'id': 11,
        'title': 'Birthday Party',
        'start': '2016-01-13T07:00:00'
      },
      {
        'id': 12,
        'title': 'Click for Google',
        'url': 'http://google.com/',
        'start': '2016-01-28'
      }
    ];

    this.events = data;


    this.cols = [
      { field: 'vin', header: 'Vin' },
      { field: 'year', header: 'Year' },
      { field: 'brand', header: 'Brand' },
      { field: 'color', header: 'Color' }
    ];

    this.cities = [];
    this.cities.push( { label: 'Select City', value: null } );
    this.cities.push( { label: 'New York', value: { id: 1, name: 'New York', code: 'NY' } } );
    this.cities.push( { label: 'Rome', value: { id: 2, name: 'Rome', code: 'RM' } } );
    this.cities.push( { label: 'London', value: { id: 3, name: 'London', code: 'LDN' } } );
    this.cities.push( { label: 'Istanbul', value: { id: 4, name: 'Istanbul', code: 'IST' } } );
    this.cities.push( { label: 'Paris', value: { id: 5, name: 'Paris', code: 'PRS' } } );

    this.chartData = {
      labels: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July' ],
      datasets: [
        {
          label: 'First Dataset',
          data: [ 65, 59, 80, 81, 56, 55, 40 ],
          fill: false,
          borderColor: '#FFC107'
        },
        {
          label: 'Second Dataset',
          data: [ 28, 48, 40, 19, 86, 27, 90 ],
          fill: false,
          borderColor: '#03A9F4'
        }
      ]
    };

    this.items = [
      { label: 'New', icon: 'p-icon-add' },
      { label: 'Open', icon: 'p-icon-archive' }
    ];
  }

  cargarMensajeResponsabilidad() {
    this.route.params.pipe(take(1)).subscribe((params: Params) => {
      this.defaultMessage = this.sanitizer.bypassSecurityTrustHtml(
        NOTIFICACIONRESPONSABILIDAD
      );
      const mosMensaje = params["mosMensaje"] ? params["mosMensaje"] : false;
      if (mosMensaje) {
        this.defaultMessage = this.sanitizer.bypassSecurityTrustHtml(
          NOTIFICACIONRESPONSABILIDAD
        );
        this.plantillaService.obtenerPorCodigo("NOTRES").subscribe(
          (res) => {
            if (res) {
              this.plantilla = this.sanitizer.bypassSecurityTrustHtml(
                res.cuerpo
              );
            }
            this.showModalNotificacionResponsabilidad = mosMensaje;
            setTimeout(() => {
              this.showModalNotificacionResponsabilidad = false;
            }, 20000);
          },
        );

      }
    });
  }

  cerrarModalResponsabilidad() {
    this.showModalNotificacionResponsabilidad = false;
  }

  cargarWidgets() {
    const listWidgets: any[] = [];
    const idUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    this.usuWidgetServicio.getByUser( idUsuario ).subscribe( ( wSelected: UsuarioWidget[] ) => {
      this.widUsuario = wSelected;
      this.rolWidgetServicio.getAllByUser( idUsuario ).subscribe( lst => {
        // si esta repetido el widget se toma el que tenga indicador obligatorio
        lst.map( x => {
          const rolwidget = lst.filter( item => item.idWidget === x.idWidget );
          if ( rolwidget.length > 1 ) {
            if ( rolwidget.filter( s => s.indicadorObligatorio ).length > 0 ) {
              this.lisRolesWidgets.push( rolwidget.filter( s => s.indicadorObligatorio )[ 0 ] );
            } else {
              this.lisRolesWidgets.push( rolwidget[ 0 ] );
            }
          } else if ( rolwidget.length === 1 ) {
            this.lisRolesWidgets.push( rolwidget[ 0 ] );
          }
        } );
        this.lisRolesWidgets.map( r => {
          this.widget = new UsuarioWidget();
          this.widget.idWidget = r.idWidget;
          this.widget.descripcion = r.widget;
          this.widget.codigoWidget = r.codigoWidget;
          this.widget.obligatorio = r.indicadorObligatorio;
          let widget = this.widUsuario.find( w => w.idWidget === r.idWidget );
          if ( widget ) {
            this.widget.idUsuario = widget.idUsuario;
            this.widget.idUsuarioWidget = widget.idUsuarioWidget;
            this.widget.visible = r.indicadorObligatorio ? r.indicadorObligatorio : widget.indicadorHabilitado;
          } else {
            this.widget.idUsuario = idUsuario;
            this.widget.idUsuarioWidget = null;
            this.widget.visible = r.indicadorObligatorio ? r.indicadorObligatorio : false;
          }

          if ( (this.widget.codigoWidget == 'ACTOFIPPD' || this.widget.codigoWidget == 'EJECOFIC' || this.widget.codigoWidget == 'PROVSPERF')
            && (this.nivUsuario == 1 || (this.nivUsuario != 5 && (!this.terCargo || !this.terCargo.idEstructuraFisica))) ) {
            this.widget.deshabilitar = true;
          }

          if ( !listWidgets.find( item => item.codigoWidget === this.widget.codigoWidget ) ) {
            listWidgets.push( this.widget );
          }
        } );
        this.todWidgets = listWidgets;
        this.carWidgets = false;
        this.todosObligatorios = this.todWidgets.every(widget => widget.obligatorio);
      } );
    } );
  }

  verWidget( code: string ) {
    const widget = this.todWidgets.find( x => x.codigoWidget === code && x.visible );
    if ( widget ) {
      return true;
    } else {
      return false;
    }
  }

  actualizarUsuarioWidget( widget: any ) {
    widget.indicadorHabilitado = widget.visible;
    if ( widget.idUsuarioWidget > 0 ) {
      this.usuWidgetServicio.update( widget ).subscribe( res => {
      } );
    } else {
      this.usuWidgetServicio.add( widget ).subscribe( res => {
        this.todWidgets[ this.todWidgets.findIndex( aw => aw.idWidget === res.idWidget ) ].idUsuarioWidget = res.idUsuarioWidget;
        widget.idUsuarioWidget = res.idUsuarioWidget;
      } );
    }
  }

  mostrarWidgets() {
    this.verWidgets = true;
  }

  cargarInformacionTercero() {
    this.nivUsuario = this.autServicio.obtenerNivelMaximo();
    this.terCargoServicio.obtenerPorTercero( this.autServicio.obtenerUsuario().idTercero ).subscribe( terCargo  => {
      this.terCargo = terCargo;
      this.cargarWidgets();
      this.carInformacionTercero = true;
      this.cargarMensajeResponsabilidad();
    } );
  }
}
